import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { OwnerFilterDropdown } from './OwnerFilterDropdown'

export const AssigneeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <OwnerFilterDropdown
        filterParam={FilterParam.ASSIGNEE}
        filterName={FilterName.ASSIGNEE}
        isNested={isNested}
      />
    )
  },
)
